import SquareEdit from "./SquareEdit";

export default SquareEdit;
